import * as React from "react";
import { motion } from "framer-motion";
import { useParams, useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Typography from '@mui/material/Typography';

import PageTemplate from '../../components/PageTemplate';
import HomeCardSection from '../../components/HomeCardSection';
import HeaderImage from '../../components/HeaderImage';
import { useFirestoreData } from "../../../context/FirestoreData.jsx";
import { gradientTextSx } from "../../../theme";

export default function Destinations({ mode }) {
  const { state } = useLocation();
  const { slug } = useParams();
  const [title, setPageTitle] = React.useState('');
  const { providers: firestoreProviders } = useFirestoreData();
  const [url, setImageUrl] = React.useState('');

  React.useEffect(() => {
    if (slug && state) {
      setPageTitle(state.name);
      setImageUrl(state.url);
    }
  }, [slug, state, firestoreProviders]);

  return (
    <PageTemplate>
      <Toolbar />
      <Box sx={{ px: { xs: 2, sm: 3 } }}>
        <Button
          component={Link}
          to="/"
          variant="text"
          startIcon={<ChevronLeftIcon />}
          sx={{ mt: 1 }}
        >
          Back
        </Button>
        <Typography variant="h4" component="h1" sx={{ ...gradientTextSx, my: 1.5 }}>
          {title}
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        {/* Destinations renders its own Back above, so suppress the overlaid one. */}
        <HeaderImage image={url} showBack={false} />
      </Box>

      <Box sx={{ px: { xs: 2, sm: 6 }, py: { xs: 3, sm: 4 } }}>
        <motion.div
          initial="initial"
          animate="enter"
          exit="exit"
          variants={{ exit: { transition: { staggerChildren: 0.1 } } }}
        >
          <HomeCardSection title={state && state.title ? state.title : ''} />
        </motion.div>
      </Box>

      <Box sx={{ px: { xs: 2, sm: 6 }, py: { xs: 1, sm: 2 } }}>
        {/* Second, untitled section is mounted without data and renders nothing
            today (HomeCardSection returns null when empty + untitled). Kept rather
            than removed — intent is ambiguous; flagged in CHECKPOINT_REPORT.md. */}
        <HomeCardSection title="" />
      </Box>
    </PageTemplate>
  );
}
